export default [
    {
        path: "add-inapp-android-setting",
        name: "addinappandroidsetting",
        component: () =>
            import(
                /* webpackChunkName: "AddSingleSubscriber" */ "../pages/inappAndroid/AddInappAndroidSetting.vue"
            ),
        meta: {
            title: `Add Inapp Android Setting`,
        },
    }
];
